import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  selector: 'epbt-fa-sale-type-list',
  templateUrl: './epbt-fa-sale-type-list.component.html',
  styleUrls: ['./epbt-fa-sale-type-list.component.scss']
})
export class EpbtFaSaleTypeListComponent implements OnInit {

  @Output() selectedSaleTypeChange = new EventEmitter<any>();
  @Input() salesTypeList: any[] = [];
  @Input() selectedSaleType: any;
  labelText: string = "Sales Type*";

  constructor() { }

  ngOnInit() {
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      this.selectedSaleTypeChange.emit(selectedValue.value);
    }
  }
}
